import React from "react";
import "./Projects.css";
 import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs,
  SiCss3,
  SiRedux,
  SiBootstrap,
  SiJson,
  SiReact,
  SiChakraui,
  SiStyledcomponents,
  SiFarfetch,
  SiGit,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title Different" data-aos="fade-right">
          Projects
        </h2>

        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://cdn.hashnode.com/res/hashnode/image/upload/v1666254871399/QQ3d6gUok.png"
                  alt="Flipkart"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Flipkart Clone</h2>
              <p>
              This website is created on MERN technology with Material UI <br />

            User can Signup and Login, choose products in to the cart and also user can buy these products <br />

            Full flow is created in this website from signup to buying a product.
              </p>
              <div>
                <SiReact />
                <SiRedux />
                <SiChakraui />
                <SiJson/>
                <SiGit />
                <SiCss3 />
              </div>
              <div>
                <a
                  href="https://flipkart-clone-project-m.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/talib789/Flipkart-Clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://snipboard.io/d2ez5l.jpg"
                  alt="DERMSTORE"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>DERMSTORE Clone</h2>
              <p>
              Dermstore is a skin care and beauty e-commerce site in the United States.This collaborative project aimed to build a Clone of an E-Commerce website for beauty Products.
              </p>
              <div>
                <SiReact />
                <SiRedux />
                <SiMaterialui />
                <SiCss3 />
                <SiExpress />
                <SiMongodb />
                <SiNodedotjs />
              </div>
              <div>
                <a
                  href="https://dermstore-clone-01.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/talib789/DermStore-Clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://snipboard.io/lqSukI.jpg"
                  alt="CoShedule"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>CoShedule Clone</h2>
              <p>
              Co-Schedule is an Online Web App that can organize, manage and schedule all your tasks in one place.
              </p>
              <div>
                <SiReact />
                <SiRedux />
                <SiChakraui />
                <SiStyledcomponents/>
                <SiJson/>
                <SiExpress />
                <SiMongodb />
                <SiNodedotjs />
              </div>
              <div>
                <a
                  href="https://coshedule.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/talib789/coShedule-with-Backend"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://snipboard.io/WTYJ0A.jpg"
                  alt="SUGAR Cosmetics"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>SUGAR Cosmetics Clone</h2>
              <p>
                This collaborative project aimed to build a Clone of an E-Commerce website for beauty Products.
              </p>
              <div>
                <SiHtml5 />
                <SiCss3 />
                <SiJavascript />
                <SiJson />
              </div>
              <div>
                <a
                  href="https://stunning-lolly-ab42a8.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/hellnoid/sugar-clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://snipboard.io/wqITYv.jpg"
                  alt="ACKO"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>ACKO Clone</h2>
              <p>
                This collaborative project aimed to build a clone Of ACKO.
                ACKO is an Insurance website cover two wheelers ,four wheelers, health Insurance and more..
              </p>
              <div>
                <SiHtml5 />
                <SiCss3 />
                <SiJavascript />
              </div>
              <div>
                <a
                  href="https://earnest-figolla-f633bb.netlify.app"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/talib789/Acko-clone-"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://snipboard.io/V4W8ty.jpg"
                  alt="Weather app"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Weather App</h2>
              <p>
              This website is completely based on APIs, and this website is a random thought of my mind <br />
This website helps in getting update of weather of user's city as well as other cities <br />
This website fetching data of all 7 days
              </p>
              <div>
                <SiHtml5 />
                <SiCss3 />
                <SiJavascript />
              </div>
              <div>
                <a
                  href="https://cozy-cat-93059e.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/talib789/Weather-App-1-2"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://snipboard.io/LhICa9.jpg"
                  alt="YouTube app"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2> YouTube Clone </h2>
              <p>
              YouTube.com is very popular Video Streaming platform over the world. 
              In this project user can search and watch any videos
              </p>
              <div>
                <SiHtml5 />
                <SiCss3 />
                <SiJavascript />
              </div>
              <div>
                <a
                  href="https://lucky-mousse-e5b6e9.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/talib789/Youtube-App"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
        
    </>
  );
};
